/** Spanish averages prompts (ADR 0051 part 3). */
export const averagesPrompts = {
    mean: (list: string) => `Halla la media de ${list}.`,
    median: (list: string) => `Halla la mediana de ${list}.`,
    mode: (list: string) => `Halla la moda de ${list}.`,
    range: (list: string) => `Halla el rango de ${list}.`,
};
